// Independently decodable, bounded WAV parts avoid proxy upload limits. Nothing is persisted.
export async function audioParts(blob) {
  const Audio = window.AudioContext || window.webkitAudioContext;
  const ctx = new Audio();
  let decoded;
  try { decoded = await ctx.decodeAudioData(await blob.arrayBuffer()); }
  finally { await ctx.close(); }
  if (decoded.duration < 0.1 || decoded.duration > 121) throw new Error("Record between a moment and two minutes.");
  const offline = new OfflineAudioContext(1, Math.ceil(decoded.duration * 16000), 16000);
  const source = offline.createBufferSource(); source.buffer = decoded; source.connect(offline.destination); source.start();
  const pcm = (await offline.startRendering()).getChannelData(0);
  const parts = [];
  for (let offset = 0; offset < pcm.length; offset += 224000) {
    let end = Math.min(offset + 224000, pcm.length);
    // Keep a tiny final tail in the preceding part (still below the15s server cap).
    if (pcm.length - end > 0 && pcm.length - end < 1600) end = pcm.length;
    const size = end - offset;
    const buffer = new ArrayBuffer(44 + size * 2); const view = new DataView(buffer);
    const word = (at, value) => [...value].forEach((c, i) => view.setUint8(at + i, c.charCodeAt(0)));
    word(0, "RIFF"); view.setUint32(4, 36 + size * 2, true); word(8, "WAVE"); word(12, "fmt ");
    view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
    view.setUint32(24, 16000, true); view.setUint32(28, 32000, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
    word(36, "data"); view.setUint32(40, size * 2, true);
    for (let i = 0; i < size; i++) { const s = Math.max(-1, Math.min(1, pcm[offset + i])); view.setInt16(44 + i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true); }
    parts.push(new Blob([buffer], { type: "audio/wav" }));
    if (end === pcm.length) break;
  }
  return parts;
}
